@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.linkshare

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.linkshare.LinkShareRewardSettingDto

object GetLinkShareRewardSettingsEndpoint :
    EndPoint<GetLinkShareRewardSettingsEndpoint.Request, GetLinkShareRewardSettingsEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val activeOnly: Boolean?,
    )

    class Response(
        val list: Array<LinkShareRewardSettingDto>,
        val total: Int,
    )
}
